document.addEventListener('DOMContentLoaded', function() {
    const faqs = document.querySelectorAll('.wp-block-klx-faq');

    faqs.forEach(faq => {
        const question = faq.querySelector('h3');
        const answerContainer = faq.querySelector('.wp-block-klx-faq__answer');
        
        // Check if the answer container has any content
        const hasContent = answerContainer && answerContainer.innerHTML.trim() !== '';
        
        // Add empty class if there's no content
        if (!hasContent) {
            faq.classList.add('empty');
        }
        
        if (question) {
            question.addEventListener('mousedown', () => {
                // Only toggle if there's content in the answer
                if (hasContent) {
                    faq.classList.toggle('open');
                }
            });
        }

        // Set initial state if open attribute is true and there's content
        if (faq.dataset.open === 'true' && hasContent) {
            faq.classList.add('open');
        }
    });
});
